<template>

  <section id="dashboard-ecommerce">
        <Keypress key-event="keyup" @success="key_press" />
    

    <b-row class="match-height">
      <b-col lg="3">
        <b-row class="match-height">
          <b-col
            lg="12"
            md="6"
          >
            <!-- <ecommerce-earnings-chart :data="data.earningsChart" /> -->
          </b-col>
         <b-col lg="12">
          <b-card>
            <b-list-group >
    <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="device in devices"
            :key="device.id"
            v-if="device.type == 'DOOR'">
      <span style="font-weight:bold;font-size:1.0rem;">{{ device.name }} <br><span style="font-size:0.8rem;color:red;">{{ last[device.id] }} </span></span>
      <b-button variant="danger" size="sm" v-if="permission_check(client_module.functions,49)"  @click="open_door(device.id)">OPEN</b-button>
    </b-list-group-item>    
  </b-list-group>
          </b-card>
         </b-col>
         

        </b-row>
      </b-col>


      <b-col lg="7">
        <ecommerce-revenue-report :data="data.revenue" />
      </b-col>
      <b-col lg="2">
         <ecommerce-statistics :data="stats" />
      </b-col>
      <b-col lg="12">
              <b-card>
       <b-table :sticky-header="true" small ref="selectableTable" selectable :select-mode="'single'" :items="items"  :fields="fields" responsive striped class="mb-0">

<template #cell(avatar)="data">
        <b-avatar
          class="mr-1"
          :src="data.item.photo_url"
        />
      </template>
<template #cell(target_name)="data">
    <b-link v-if="data.item.target_type == 'MEMBER'" :to="'/apps/member/edit/'+data.item.taget_token+'/'">
        <b>{{data.item.target_name}}</b></b-link>
    <b-link v-if="data.item.target_type == 'STAFF'" :to="'/apps/staff/edit/'+data.item.taget_token+'/'"><b>{{data.item.target_name}}</b></b-link>
    <span v-if="data.item.tags !== null">
             <b-badge v-for="tag in data.item.tags" :key="index" class='ml-1' :variant="'warning'">
              {{tag}}
            </b-badge>
            </span>
</template>

<template #cell(plan_type)="data">
    <b-badge variant="primary">{{ data.item.plan_type }}</b-badge>
</template>
    </b-table>
    </b-card>
    
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BAvatar,BCol, BCard, BButton,BListGroup,BListGroupItem,BTable } from 'bootstrap-vue'

import { getUserData } from '@/auth/utils'
import EcommerceMedal from './EcommerceMedal.vue'
import EcommerceStatistics from './EcommerceStatistics.vue'
import EcommerceRevenueReport from './EcommerceRevenueReport.vue'
import EcommerceOrderChart from './EcommerceOrderChart.vue'
import EcommerceProfitChart from './EcommerceProfitChart.vue'
import EcommerceEarningsChart from './EcommerceEarningsChart.vue'
import EcommerceCompanyTable from './EcommerceCompanyTable.vue'
import EcommerceMeetup from './EcommerceMeetup.vue'
import EcommerceBrowserStates from './EcommerceBrowserStates.vue'
import EcommerceGoalOverview from './EcommerceGoalOverview.vue'
import EcommerceTransactions from './EcommerceTransactions.vue'

export default {
  components: {
    BRow,
    BAvatar,
    BCol,
    Keypress: () => import('vue-keypress'),
    BButton,
    BCard,
    EcommerceMedal,
    BListGroup,
    BTable,
    BListGroupItem,
    EcommerceStatistics,
    EcommerceRevenueReport,
    EcommerceOrderChart,
    EcommerceProfitChart,
    EcommerceEarningsChart,
    EcommerceCompanyTable,
    EcommerceMeetup,
    EcommerceBrowserStates,
    EcommerceGoalOverview,
    EcommerceTransactions,
  },
  data() {
    return {
      data: {},
       fields: [
                { key: 'avatar', label: 'Avatar' },
                { key: 'code', label: 'Code' },
                { key: 'name', label: 'Name' },
                { key: 'datetime', label: 'Entry Time' },
                { key: 'plan_type', label: 'Plan Type' },
                { key: 'expire', label: 'Expire' },
            ],
            /* eslint-disable global-require */
            items: [],
      centerId: 0,
      stats: {},
      centerName: '',
      devices: {},
      client_module:JSON.parse(localStorage.getItem('userData')),
      last : {},
      key_press_enabled : true,
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
watch: {
  last_person: {
    handler(newValue) {
      console.log(this.items)
        if (this.items.length > 0) {
          this.items.foreach((record) => {
          if (record.code == newValue.code) {
            if (record.timestamp - 30 < newValue.timestamp) {
              console.log('skip duplicate')
              return
            }
          }
        })
      }

      // 更新 last display
      if (newValue.user_type === 'MEMBER') {
        this.last[newValue.device] = newValue.code
      } else {
        this.last[newValue.device] = newValue.name
      }

      // 新紀錄 (深拷貝)
      const record = JSON.parse(JSON.stringify(newValue))

      // 放最頂
      this.items.unshift(record)

      // 限制最多 20 條
      if (this.items.length > 20) {
        this.items.splice(20)  // 刪除索引 20 後的全部
      }

      // 更新 stats
      this.get_stats()
    },
    deep: true,
  },
},
  computed :{
    last_person() {
      return this.$store.getters['center/last_person']
    },
  },
  methods: {
    get_stats() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/center/`+this.$store.getters['center/currentCenterId']+`/dashboard/stats/`)
        .then(res => {
          this.stats = res.data
        })
    },
    key_press(r) {
        if (this.key_press_enabled === false) {
            return
        }
        if (r.event.keyCode == 123) {
            open_door
        }
    },
    get_device() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/center/${this.centerId}/device/`)
        .then(res => {
          this.devices = res.data
        })
    },
    open_door(sn) {
      this.$http.post(process.env.VUE_APP_AC_API_BASE+`/set_door/`+sn+`/on`)
        .then(res => {

        })
    },
  },
  created() {
    this.$http.defaults.headers.Token = this.userData.token
    this.centerId = this.$store.getters['center/currentCenterId']
    this.centerName = this.$store.getters['center/currentCenterName']
    this.get_device()
    this.get_stats()
//    console.log(process.env.VUE_APP_API_BASE)
    // data
    this.$http.get('/ecommerce/data')
      .then(response => {
        this.data = response.data

        // ? Your API will return name of logged in user or you might just directly get name of logged in user
        // ? This is just for demo purpose
        const userData = getUserData()
        this.data.congratulations.name = userData.fullName.split(' ')[0] || userData.username
      })
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
